import { render, staticRenderFns } from "./FormBiayaReadonly.vue?vue&type=template&id=ec37d67a&"
import script from "./FormBiayaReadonly.vue?vue&type=script&lang=js&"
export * from "./FormBiayaReadonly.vue?vue&type=script&lang=js&"
import style0 from "./FormBiayaReadonly.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports